<div class="air-details-container">

  <p class="shoutBorder">
    <strong>OERI Last Called TLR: </strong>{{ oeriStatistics.lastCalled }}
    <strong>Installed TLR's Provided to OERI:</strong>
    {{ oeriStatistics.openTlr }}
    <strong> TLR's Removed in the Last 30 Days: </strong
    >{{ oeriStatistics.removedIn30days }}
  </p>
  <div class="titleBlock">
    <div class="section-title">
      Discovered Past 60 Days Report - Build Search
    </div>
    <div *ngIf="isShowMainBlock">
      <button (click)="backBtn()" class="btn-secondary">Back</button>
    </div>
  </div>
  <div *ngIf="!isShowMainBlock">
    <div class="partioned-table">
      <div class="row">
        <div class="cell label label-text">Divison</div>
        <div class="cell value">
          <p-dropdown
            [options]="divisionList"
            [(ngModel)]="filters.division"
            [optionLabel]="'name'"
            [optionValue]="'value'"
            placeholder="ALL"
            class="dropdown"
            class="custom-dropdown"
            panelStyleClass="custom-dropdown-panel"
          ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Section</div>
        <div class="cell value">
          <p-dropdown
            [options]="sectionsList"
            [optionLabel]="'name'"
            [optionValue]="'value'"
            placeholder="ALL"
            class="dropdown"
            class="custom-dropdown"
            [(ngModel)]="filters.section"
          ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Plant</div>
        <div class="cell value">
          <p-dropdown
            [options]="plantList"
            [optionLabel]="'name'"
            [optionValue]="'value'"
            placeholder="ALL"
            class="dropdown"
            class="custom-dropdown"
            [(ngModel)]="filters.plant"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="button-row">
      <button pButton (click)="runReport()" class="btn-primary">Run Report</button>
    </div>
  </div>

  <div *ngIf="isShowMainBlock">
    <div class="table-chart-container mt-10">
      <div class="display-flex">
        <p class="m-0">
          Division : <b>{{ filters.division }}</b> 
          Section : <b>{{ filters.section }} </b> 
          Plant : <b>{{ filters.section }}</b>
        </p>

        <div class="exportToExcel excel-btn">
          <div class="actions">
            <button
              pButton
              type="button"
              label="Export To Excel"
              class="btn-primary"
              (click)="exportToExcel()"
            >
              Export To Excel
            </button>
          </div>
        </div>
      </div>
      <p-table
        [value]="reportData"
        paginator="true"
        [rows]="25"
        responsiveLayout="scroll"
        styleClass="p-datatable-gridlines"
        id="StyleTable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Entry Date</th>
            <th>Op. User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. PSI</th>
            <th>Op. Temp</th>
            <th>Shutdown Description</th>
            <th>Service</th>
            <th>Insp. User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>Eng. User ID</th>
            <th>TLR Type</th>
            <th>Maximo WO Number</th>
            <th>Maximo Outage-T/A</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr let data of reportData>
            <td (click)="details(data)" class="linkUnderline">
              {{ data.Tag_Number }}
            </td>
            <td>{{ data.Data_Entry_Date | date : "M/d/yyyy" }}</td>
            <td>{{ data.Operator_CAI }}</td>
            <td>{{ data.Division }}</td>
            <td>{{ data.Section }}</td>
            <td>{{ data.Plant }}</td>
            <td>{{ data.LDAR }}</td>
            <td>{{ data.Oper_PSI }}</td>
            <td>{{ data.Oper_Temp }}</td>
            <td>{{ data.ShutdownDescription }}</td>
            <td>{{ data.Service }}</td>
            <td>{{ data.InspectionCAI }}</td>
            <td>{{ data.ServiceClass }}</td>
            <td>{{ data.OACAI }}</td>
            <td [ngClass]="commonService.getDateColorClass(data.Permanent_Repair_Date)">{{ data.Permanent_Repair_Date | date : "M/d/yyyy" }}</td>
            <td>{{ data.EngineeringCAI }}</td>
            <td>{{ data.TLRType }}</td>
            <td>{{ data.Maximo_WO_Number }}</td>
            <td>{{ data.Maximo_Outage_T_A }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
